import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import CIBCMemberInformationForm from "webapp/components/Partner/CIBC/CIBCMemberInformationForm/CIBCMemberInformationForm";
import PPUConsentScreen from "webapp/components/Partner/CIBC/PPUConsentScreen/PPUConsentScreen";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function CIBCMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showPPUModal, setShowPPUModal] = useState(false);
  const [isPPUAccept, setIsPPUAccept] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onPPUYes = () => {
    setShowPPUModal(false);
    setIsPPUAccept(true);
    onUserNextNew();
  };

  const onPPUNo = () => {
    setShowPPUModal(false);
  };

  const onUserNextNew = () => {
    devLog("onUserNext");

    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
    if (memberInfo && selectedMember) {
      devLog("onMemberNext", memberInfo?.name);
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          memberRef: selectedMember.memberRef,
          contactRef: selectedMember.memberRef,
          Year: memberInfo.year,
          fullName: memberInfo.fullName,
          firstName: props.currState.FirstName,
          lastName: props.currState.lastName,
          Make: memberInfo.make,
          Model: memberInfo.model,
          Color: memberInfo.color,
          Weight: memberInfo.weight,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      // props.context.setState(
      //   {
      //     MemberNumber: null,
      //     webAppState: AppState.ConfirmVehicle,
      //   },
      //   () => {}
      // );

      setShowSelectUserModal(true);
    }
  };

  const onUserNext = () => {
    devLog("onUserNext");

    /**
     * OOP / PPU consent is only for member-not-found (shown in the form).
     * When search returns an account, do not show the OOP modal — including
     * when the user chooses "Add a New Driver".
     */
    const hasSearchResult =
      memberInfo && (Array.isArray(memberInfo) ? memberInfo.length > 0 : typeof memberInfo === "object");

    devLog("isPPUAccept", isPPUAccept, "isNew", isNew, "hasSearchResult", hasSearchResult);
    if (isNew && !isPPUAccept && !hasSearchResult) {
      setShowPPUModal(true);
      return;
    }

    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
    //When LMC & CIBC have account and contact
    if (memberInfo && selectedMember) {
      devLog("onMemberNext", memberInfo?.name);
      devLog("selectedMember", selectedMember);
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          contactRef: selectedMember.contactRef,
          memberRef: selectedMember.memberRef,
          Year: memberInfo.year,
          fullName: memberInfo.fullName,
          firstName: memberInfo.firstName,
          lastName: memberInfo.lastName,
          Make: memberInfo.make,
          Model: memberInfo.model,
          Color: memberInfo.color,
          Weight: memberInfo.weight,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else if (selectedMember && !memberInfo) {
      //When LMC has contact but not account
      devLog("onMemberNext", memberInfo?.name);
      devLog("selectedMember", selectedMember);
      props.context.setState(
        {
          contactRef: selectedMember.contactRef,
          memberRef: selectedMember.memberRef,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      // props.context.setState(
      //   {
      //     MemberNumber: null,
      //     webAppState: AppState.ConfirmVehicle,
      //   },
      //   () => {}
      // );

      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onUserSelectMember = (account, contact) => {
    devLog("onUserSelectMember", account, contact);
    setMemberInfo(account);
    setSelectedMember(contact);
    setIsNew(false);
    setIsPPUAccept(false);
  };

  const onUserSelectMemberNew = (contractData, member) => {
    if (props.currState.partner === "CIBC") {
      devLog("onUserSelectMemberNew", contractData, member);
      setMemberInfo(contractData);
      setSelectedMember(member);
      setIsNew(true);
      setIsPPUAccept(false);
    } else {
      devLog("onUserSelectMemberNew", contractData, member);
      setMemberInfo(contractData);
      setSelectedMember(member);
      setIsNew(false);
      setIsPPUAccept(false);
    }
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("APIA.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <CIBCMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onSelect={onUserSelectMember}
          onSelectNew={onUserSelectMemberNew}
        />
      </div>

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}

      {showPPUModal && props.currState.partner === "CIBC" ? (
        <PPUConsentScreen
          context={props.context}
          currState={props.currState}
          onYes={onPPUYes}
          onNo={onPPUNo}
          partnerCode={props.currState.localGroup}
        />
      ) : (
        <></>
      )}

      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}

export default CIBCMemberInformation;
